import {createModel} from '@@/package/utils/ModelUtil';
import Model from '@@/package/mapper/Model';
import {ContestStatusType} from "~~/package/mapper/contest/model/ContestStatusType";

export class ContestListModel extends Model {
    constructor(
        public id: number = 1,
        public title: string = "",
        public description: string = "",
        public overView: string = "",
        public imageUrl: string = "",
        public progressType: string = "",
        public progressTypeDate: number = 0,
        public participateFlag: boolean = true,
        public awardType: string = "",
        public awardAmount: number = 0,
        public totalParticipate: number = 0,
        public recentTaskId: number = 0,
        public contestType: string = "",
        public userTermsFlag: boolean = false,
        public status: string = ContestStatusType.NULL,
        public startedAt: string | null = null,
        public endedAt: string | null = null,
        public termsAgreeFlag: boolean = false,
        public useMultiMonitorProctor: boolean = false,
        public useTabSwitchProctor: boolean = false,
        public useCopyPasteProctor: boolean = false,
        public useScreenRecording: boolean = false,
        public useShortcutProctor: boolean = false,
        public agreeOnScreenRecording: boolean = false
    ) {
        super();
    }

    public static create(model: Partial<ContestListModel>): ContestListModel {
        return createModel<ContestListModel>(ContestListModel, {
            ...model
        });
    }
}
